<template></template>
<script>
export default {
  name: "dealers"
};
</script>

<style lang="scss" scoped>
</style>